import { ProductFormatFulfilment, DigitalFormatButtonTitle } from './constants';

export default function getProductFormatName(format) {
  return format.fulfilment === ProductFormatFulfilment.Digital
    ? DigitalFormatButtonTitle
    : format.name;
}
